"use strict";

angular.module("core")
.controller("listingFilterModalController", function($scope, $attrs, close, UserService) {
    $scope.filters = $attrs.filters;
    $scope.modalTitle = $attrs.modalTitle;
    $scope.statusService = $attrs.statusService;
    $scope.tagService = $attrs.tagService;
    $scope.userData = null;

    UserService.isUserFetched().then(function onSuccess(user) {
        $scope.userData = user;
    });

    angular.forEach($attrs.componentFiltersEmitter, function(filter) {
        $scope.$on(filter, function(event, value) {
            angular.extend($scope.filters, value);
        });
    });

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    this.cancel = function() {
        this.close();
    };

    this.updateFilter = function() {
        this.close($scope.filters);
    };

    this.clearFilter = function() {
        angular.forEach($attrs.availableFilterParams, function(filter) {
            if ($scope.filters.hasOwnProperty(filter)) {
                $scope.filters[filter] = null;
            }
        });
        $scope.filters["clear"] = true;
        this.updateFilter();
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/listing-filter/modal/listing-filter.modal.js
// module id = 662
// module chunks = 0